"use client";
import Image from "next/image";
import { AspectRatio, Stack, SimpleGrid } from "@chakra-ui/react";
import { Heading } from "@/elements";
import { useHeadingVariant } from "@/theme/hooks/useSectionStyle";
import { CYBER_SEC_TECH_STACK_CONSTANTS } from "./constants";

const VulnerabilitySecStack = () => {
  const HeadingVariant = useHeadingVariant();
  const { title, list } = CYBER_SEC_TECH_STACK_CONSTANTS;
  return (
    <Stack gap={10} mb={6}>
      <Heading variant={HeadingVariant} textAlign={"center"} px={2}>
        {title}
      </Heading>
      <SimpleGrid
        columns={{ base: 3, md: 5 }}
        columnGap={{ base: 3, sm: 5 }}
        justifyContent={"center"}
        alignItems={"center"}
        rowGap={10}
        px={{ base: 3, xl: 28, "2xl": 40 }}
        py={10}
      >
        {list.map((stack, index) => {
          return (
            <AspectRatio ratio={2 / 1} key={index} position="relative" maxW="160px">
              <Image
                src={stack.logo}
                alt={stack.name}
                fill
                style={{
                  objectFit: "contain",
                  objectPosition: "center",
                }}
              />
            </AspectRatio>
          );
        })}
      </SimpleGrid>
    </Stack>
  );
};

export default VulnerabilitySecStack;
